(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["comfort-media-tabs"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-comfort-tabs]').forEach((root) => {
    if (root.dataset.comfortTabsReady === 'true') return;
    root.dataset.comfortTabsReady = 'true';

    const triggers = root.querySelectorAll('[data-comfort-trigger]');
    const panels = root.querySelectorAll('[data-comfort-panel]');
    const callouts = root.querySelectorAll('[data-comfort-callout]');
    const playButton = root.querySelector('[data-comfort-play]');
    let activeIndex = 0;

    const activePanelVideo = () => {
      const panel = panels[activeIndex];
      if (!panel) return null;
      const mobileMedia = panel.querySelector('.comfort-tabs__media--mobile');
      const desktopMedia = panel.querySelector('.comfort-tabs__media--desktop');
      const media = window.matchMedia('(max-width: 749px)').matches && mobileMedia ? mobileMedia : desktopMedia;
      return media && media.tagName === 'VIDEO' ? media : null;
    };

    const syncPlayButton = () => {
      if (!playButton) return;
      const video = activePanelVideo();
      if (!video) {
        playButton.classList.remove('is-visible', 'is-paused');
        return;
      }

      playButton.classList.add('is-visible');
      playButton.classList.toggle('is-paused', video.paused);
      playButton.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
    };

    const activate = (index) => {
      if (activeIndex === index) return;
      activeIndex = index;

      triggers.forEach((trigger, triggerIndex) => {
        const isActive = triggerIndex === index;
        trigger.classList.toggle('is-active', isActive);
        trigger.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach((panel, panelIndex) => {
        const isActive = panelIndex === index;
        panel.classList.toggle('is-active', isActive);
        panel.querySelectorAll('video').forEach((video) => {
          if (isActive) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      });

      callouts.forEach((callout) => {
        callout.classList.toggle('is-active', Number(callout.dataset.comfortCallout) === index);
      });

      syncPlayButton();
    };

    triggers.forEach((trigger, index) => {
      trigger.addEventListener('click', () => activate(index));
    });

    if (playButton) {
      playButton.addEventListener('click', () => {
        const video = activePanelVideo();
        if (!video) return;

        if (video.paused) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }

        syncPlayButton();
      });
    }

    window.addEventListener('resize', syncPlayButton);
    activeIndex = -1;
    activate(0);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hover-tab-content"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-hover-tab-banner]').forEach((sectionRoot) => {
    const tabButtons = sectionRoot.querySelectorAll('.btn-box');
    const desktopImages = sectionRoot.querySelectorAll('.pc-image');

    tabButtons.forEach((button, index) => {
      button.addEventListener('mouseenter', () => {
        tabButtons.forEach((btn) => {
          btn.classList.remove('is-active');
          btn.setAttribute('aria-selected', 'false');
        });

        desktopImages.forEach((image) => {
          image.classList.remove('is-active');
        });

        button.classList.add('is-active');
        button.setAttribute('aria-selected', 'true');

        const targetImage = desktopImages[index];
        if (!targetImage) return;

        if (document.startViewTransition) {
          document.startViewTransition(() => {
            targetImage.classList.add('is-active');
          });
        } else {
          targetImage.classList.add('is-active');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-comparison-alpine"] && !Shopify.designMode) return;
  try {
    
  window.specComparison = {
    allProducts: [],
    selectedProducts: [],
    specTitles: [],
    showDifferencesOnly: false,
    priceLabel: 'Price',

    init(rootEl) {
      let el = rootEl ? rootEl.previousElementSibling : null;
      if (!el || !el.hasAttribute || !el.hasAttribute('data-product-json')) {
        el = document.querySelector('[data-product-json]');
      }

      if (!el) {
        console.warn('data-product-json not found for product comparison section');
        return;
      }

      const raw = el.textContent.trim();
      let data = [];
      try {
        data = JSON.parse(raw || '[]');
      } catch (e) {
        console.error('JSON parse error in product comparison section:', e);
        return;
      }

      this.allProducts = data.map((p) => ({
        id: String(p.id),
        handle: p.handle,
        title: p.title,
        price: p.price,
        image: p.image,                           
        specs: Array.isArray(p.specs) ? p.specs : []
      }));

      const defaultSelected = this.allProducts.slice(0, 2).map((p) => p.id);
      this.selectedProducts = defaultSelected.length > 0
        ? defaultSelected
        : this.allProducts.map((p) => p.id);

      const paramAttr = rootEl.getAttribute('data-parameter-titles') || '[]';
      let configuredTitles = [];
      try {
        configuredTitles = JSON.parse(paramAttr);
      } catch (e) {
        configuredTitles = [];
      }

      this.specTitles = configuredTitles;
    },

    getProduct(id) {
      const stringId = String(id);
      return this.allProducts.find((p) => p.id === stringId) || {};
    },

    toggleProduct(id) {
      const stringId = String(id);
      const index = this.selectedProducts.indexOf(stringId);
      if (index !== -1) {
        this.selectedProducts.splice(index, 1);
      } else {
        this.selectedProducts.push(stringId);
      }
    },

    getSpec(productId, title) {
      const product = this.getProduct(productId);
      if (!Array.isArray(product.specs)) return null;

      const normalize = (s) =>
        (s || '')
          .toString()
          .trim()
          .toLowerCase()
          .replace(/\s+/g, ' ');

      const t = normalize(title);

      return product.specs
        .map(item => {
          const [value, key] = item.split('--');

          return {
            value: (value || '').trim(),
            key: normalize(key),
          };
        })
        .find(spec => spec.key === t) || null;
    },

    isRowAllSame(title) {
      if (this.selectedProducts.length <= 1) return false;

      const values = this.selectedProducts.map((id) => {
        const spec = this.getSpec(id, title);
        return spec ? spec.value : null;
      });

      return values.every((value) => value === values[0]);
    },

    isPriceRowAllSame() {
      if (this.selectedProducts.length <= 1) return false;

      const values = this.selectedProducts.map((id) => {
        const product = this.getProduct(id);
        return Number(product.price) || 0;
      });

      return values.every((value) => value === values[0]);
    },

    isRowAllSameOrPrice(title) {
      if (title === this.priceLabel) {
        return this.isPriceRowAllSame();
      }
      return this.isRowAllSame(title);
    },

    formatMoney(price) {
      const num = Number(price) || 0;
      return '$' + (num / 100).toFixed(2);
    },

    getFormattedTitle(product) {
      return product.title || '';
    }
  };

  } catch(e) { console.error(e); }
})();
})();
